document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.image-slider-swiper');
    let total_swipers = [];

    elements.forEach(element => {
        const heroSwiper = new Swiper(element, {
            loop: true,
            slidesPerView: 2.8,
            //centeredSlides: true,
            spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
    
                768: {
                    slidesPerView: 'auto',
                },
                1120: {
                    slidesPerView: 'auto',
                },
                1230: {
                  slidesPerView: 'auto',
                }
            },
        });

        total_swipers.push(heroSwiper);
    });
    
    let activeIndexs = [];
    
    // Save the current active index when the tab loses focus
    window.addEventListener('blur', function() {

        total_swipers.forEach((swiper, index) => {
            activeIndexs[index] = swiper.activeIndex; 
        });
    });

    // Restore the active index when the tab gains focus
    window.addEventListener('focus', function() {
        if (total_swipers) {
            total_swipers.forEach((swiper, idx) => {
                swiper.slideTo(activeIndexs[idx], 0);
            });
        }
    });
});

